// ContraindicationsDialog.jsx (controlled)
import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Info, AlertCircle, Loader2 } from 'lucide-react';

export default function LabAdditionalRegistrationDialog({
  open,
  onOpenChange,
  onAccept,
  onAddMore,
  selectedSlotTime,
  loadingButton,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        onOpenChange(isOpen); // bubble to parent
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Registracija tyrimui</DialogTitle>
        </DialogHeader>
        <DialogBody className="space-y-6 max-h-[75dvh] overflow-y-auto">
          <div className="space-y-4 text-center">
            Pasirinktas laikas ({selectedSlotTime}). Pereiti į registraciją ar
            pridėti dar tyrimų?
          </div>
        </DialogBody>

        <DialogFooter>
          <Button
            variant="outline"
            disabled={loadingButton}
            onClick={async () => {
              const success = await onAddMore(true); // wait for parent handler
              if (success !== false) {
                onOpenChange(false); // close only after completion
              }
            }}
          >
            {loadingButton && (
              <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
            )}
            Pridėti dar tyrimų
          </Button>
          <Button
            variant="secondary"
            disabled={loadingButton}
            onClick={async () => {
              const success = await onAccept(true); // wait for parent handler
              onOpenChange(false);
              if (success !== false) {
                onOpenChange(false); // close only after completion
              }
            }}
          >
            {loadingButton && (
              <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
            )}
            Pereiti į registraciją
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
